// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__GP5fV9vpgBvzM"};